const versionAPI = 'v1'

const APIEndpoint =
  process.env.NODE_ENV !== 'production' || process.env.VUE_APP_TEST === 'e2e'
    ? '/' + versionAPI
    : process.env.VUE_APP_API_BASE_URL + versionAPI

const PixelEndpoint =
  process.env.NODE_ENV !== 'production' || process.env.VUE_APP_TEST === 'e2e'
    ? 'http://localhost:8080/' + versionAPI
    : process.env.VUE_APP_API_BASE_URL + versionAPI

export { versionAPI, APIEndpoint, PixelEndpoint }
